<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :searchs="searchs" :form-fields="formFields"
                  :permission="permission" :reUrl="reUrl" :feUrl="feUrl"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'PaymentCategory',
  components: {CommonTable},
  data() {
    return {
      reUrl: process.env.VUE_APP_BASE_API || '',
      feUrl: process.env.VUE_APP_FE_URL || '',
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'paymentCategory:add',
        update: 'paymentCategory:update',
        delete: 'paymentCategory:delete',
        deleteBatch: 'paymentCategory:deleteBatch'
      },
      url: {
        get: '/paymentCategory/listByCondition',
        add: '/paymentCategory/add',
        update: '/paymentCategory/update',
        delete: '/paymentCategory/delete',
        delete_batch: '/paymentCategory/deleteBatch',
        status: '/paymentCategory/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },{
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      },
        {
          field: 'icon',  // 字段名
          label: '图标',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          img: true,  // 添加图片显示
          width: '100',
        },{
          field: 'name',  // 字段名
          label: '类别',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'sort',  // 字段名
          label: '排序',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          status: true,
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },{
            field: 'agentId',
            label: '代理',
            type: 'select',
            selectUrl: '/agent/getAll',
            selectData: [],
            placeholder: '请选择',
            rules: [{
              message: '请选择代理', trigger: 'blur', required: true
            }],
            add: true,
            update: true,
          },
          {
            field: 'icon',  // 字段名
            label: '图标',  // 字段显示名称
            type: 'input',
            placeholder: '请输入icon',
            rules: [
              { required: true, message: 'icon不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          },{
            field: 'name',  // 字段名
            label: '类别',  // 字段显示名称
            type: 'input',
            placeholder: '请输入类别名称',
            rules: [
              { required: true, message: '类别名称不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },{
            field: 'sort',  // 字段名
            label: '排序',  // 字段显示名称
            type: 'input',
            placeholder: '请输入序号',
            rules: [
              { required: true, message: '序号不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },{
            field: 'status',  // 字段名
            label: '状态',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              { required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: false,
            update: true,
          },
        ]
      },
      operate: [{
        icon: 'el-icon-upload2',
        type: 'text',
        text: '上传图标',
        uploadImg: true,
        url: this.reUrl + '/system/upload/oss/img',
        // 用于存储handle的row
        value: {},
        handle: (row) => {
          this.value = row;
        },
        success: (res) => {
          if (res.code === 0) {
            const value = JSON.parse(JSON.stringify(this.value));
            value.icon = res.data;
            this.$axios.post({
              url: '/paymentCategory/update',
              data: value,
              success: (data) => {
                if (data.code === 0){
                  this.$message.success("图标上传成功");
                  this.$set(this.value, 'icon', value.icon);
                }else {
                  this.$message.error(data.msg ? data.msg: "图标上传失败");
                }
              }
            });
          } else if (res.code === 102) {
            window.localStorage.removeItem('username');
            window.localStorage.removeItem('sessionId');
            window.parent.location.href = this.feUrl + '/login.html';
          }
        }
      }]
    }
  }
}
</script>

<style scoped>

</style>
